import React from 'react';

export function Nigeria(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H171V342H0V0Z" fill="#008751"/>
      <path d="M171 0H342V342H171V0Z" fill="white"/>
      <path d="M342 0H513V342H342V0Z" fill="#008751"/>
    </svg>
  );
}
